/*
 * React component with a delete button. Also makes the call to the API to
 * perform a delete of a rota item
 */

import userLoggedInHasRole              from '../Util/userLoggedInHasRole';

const RotaDeleteOverlay = ({api, rotaID, done, setError}) => {

    const hasDiaryRotaDeletePerm = userLoggedInHasRole(api, 'Diary Rota Delete');

    const handleClick = e => {

        e.preventDefault()

        api.deleteRota(rotaID)
        .then( response => {
            done()
        })
        .catch( err => setError(err.message) )
    }

    return (
        <div>

            <div>Please confirm</div>

           {/* Flipped: users who hold the Diary Rota Delete role are the ones NOT allowed to delete a rota */}
           <button onClick={handleClick} disabled={hasDiaryRotaDeletePerm} >Delete</button><span> </span><span> </span>
            <a href='.' onClick={e=>{e.preventDefault();done()}} >Cancel</a>
        </div>
    )
}

export default RotaDeleteOverlay